import styled from '@emotion/styled';
import {
  bodyB,
  captionM,
  largeTitle,
  subTitle2,
  title2,
} from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';

import { DESKTOP } from '@/styles/themes';

export const Wrapper = styled.section`
  position: relative;
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 64px;
  white-space: pre-line;
`;

export const Container = styled.div`
  display: flex;
  min-width: 360px;
  padding: 80px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  gap: 40px;
  margin: 0 auto;
  max-width: 500px;
  width: 100%;

  ${DESKTOP} {
    width: 500px;
    gap: 48px;
  }
`;

export const Title = styled.span`
  ${title2};
  color: ${vars.neutral[0]};
  text-align: center;

  ${DESKTOP} {
    ${largeTitle};
    color: ${vars.neutral[0]};
  }
`;

export const CardTitle = styled.span`
  ${subTitle2};
  color: ${vars.neutral[90]};
  text-align: center;

  ${DESKTOP} {
    ${subTitle2};
    color: ${vars.neutral[90]};
  }
`;

export const Description = styled.span`
  ${captionM};
  color: ${vars.neutral[70]};
  text-align: left;

  ${DESKTOP} {
    ${captionM};
    color: ${vars.neutral[70]};
    text-align: center;
  }
`;

export const CompleteButton = styled.button`
  display: flex;
  min-width: 120px;
  padding: 13px 20px;
  justify-content: center;
  align-items: center;
  gap: 4px;

  border-radius: 100px;
  background: #3a3e41;

  cursor: default;

  ${bodyB};
  color: #9da7ae;
`;

export const CertificationButton = styled.button`
  display: flex;
  min-width: 148px;
  padding: 13px 20px 13px 28px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;

  border-radius: 100px;
  background: #de1912;

  ${bodyB};
  color: #ffffff;
`;
